exports.currencyUnit = '$';
exports.consumptionUnit = 'kWh';
